export default __webpack_public_path__ + "static/media/card-image-bronze.508511ed.png";